import Vue from 'vue';

import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);
const { screens } = fullConfig.theme;

// Refer:
// https://dev.to/jsbaguette/tailwind-vuejs-breakpoint-reactivity-2al7
// https://stackoverflow.com/questions/59982018/how-do-i-get-tailwinds-active-breakpoint-in-javascript
// https://tailwindcss.com/docs/configuration#referencing-in-java-script

const getBreakpointValue = (value) => +value.slice(0, value.indexOf('px'));
const xs = (val) => val >= getBreakpointValue(screens.xs.min)
  && val <= getBreakpointValue(screens.xs.max);
const sm = (val) => val >= getBreakpointValue(screens.sm.min)
  && val <= getBreakpointValue(screens.sm.max);
const md = (val) => val >= getBreakpointValue(screens.md.min)
  && val <= getBreakpointValue(screens.md.max);
const lg = (val) => val >= getBreakpointValue(screens.lg) && val <= getBreakpointValue(screens.xl);
const xl = (val) => val >= getBreakpointValue(screens.xl);

const debounce = (func, wait) => {
  let timeout;
  return () => {
    const later = () => {
      timeout = null;
    };
    const callNow = !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func();
    }
  };
};

const breakpoints = Vue.observable({
  xs: xs(window.innerWidth),
  sm: sm(window.innerWidth),
  md: md(window.innerWidth),
  lg: lg(window.innerWidth),
  xl: xl(window.innerWidth),
});

window.addEventListener(
  'resize',
  debounce(() => {
    breakpoints.xs = xs(window.innerWidth);
    breakpoints.sm = sm(window.innerWidth);
    breakpoints.md = md(window.innerWidth);
    breakpoints.lg = lg(window.innerWidth);
    breakpoints.xl = xl(window.innerWidth);
  }, 0), // NOTE: Can set timeout if needed
  false,
);

export default {
  install(vue) {
    // eslint-disable-next-line no-param-reassign
    vue.prototype.$breakpoints = breakpoints;
  },
};
